import React, { useState } from 'react';
import {
  ToothAngMDIcon,
  ToothRotMDIcon,
  ToothTorqBLIcon,
  ToothTranBLIcon,
  ToothTranEIIcon,
  ToothTranMDIcon,
} from 'assets/images/teeth-movement-table';
import { cn } from '@utils';
import styles from './styles.scss';
import { CloseButton } from '@view/components';
import { ToothOriginPointSelect } from '@view/widgets/TeethMovement/Header/ToothOriginPointSelect';
import { ToothMovementPoints } from '@data/models';

type HeaderProps = {
  onClose: () => void;
  isLabelsHidden?: boolean;
  selectedToothOriginPoint?: ToothMovementPoints;
  setSelectedToothOriginPoint?: (
    selectedToothOriginPoint: ToothMovementPoints
  ) => void;
  defaultOriginPoint: ToothMovementPoints;
};

const Header = ({
  onClose,
  isLabelsHidden,
  selectedToothOriginPoint,
  setSelectedToothOriginPoint,
  defaultOriginPoint,
}: HeaderProps) => {
  return (
    <div className={cn(styles.teethMovementHeader)}>
      <div className={cn(styles.teethMovementHeader_top)}>
        <button
          type="button"
          className={cn(styles.teethMovementHeader_top_backButton)}
          onClick={onClose}
        >
          <span className="sr-only">Close panel</span>
          <img
            width={16}
            src="/assets/images/arrow_left.svg"
            alt="Close icon"
          />
        </button>
        <h2 className={cn(styles.teethMovementHeader_top_title)}>
          Tooth Movement Table
        </h2>
        <CloseButton className="hidden sm:block" onClick={onClose} size="sm" />
      </div>
      <div className="flex gap-[32px] px-[32px]">
        {selectedToothOriginPoint && (
          <ToothOriginPointSelect
            selectedToothOriginPoint={selectedToothOriginPoint}
            setSelectedToothOriginPoint={setSelectedToothOriginPoint}
            defaultOriginPoint={defaultOriginPoint}
          />
        )}
        <div className="mt-2">
          <div className="text-lg text-space font-bold select-none">
            Reference point
          </div>
          <div className="text-space text-opacity-60 text-[12px] leading-tight font-medium">
            The values in the table correspond to the selected reference point
          </div>
        </div>
      </div>
      <div
        className={cn(
          styles.teethMovementHeader_bottom,
          isLabelsHidden && 'hidden'
        )}
      >
        <div className={cn(styles.teethMovementHeader_bottom_container)}>
          <div className={cn(styles.teethMovementHeader_bottom_cell)}>
            <div className={cn(styles.teethMovementHeader_bottom_iconWrapper)}>
              <ToothTranEIIcon />
            </div>
            <div className={cn(styles.teethMovementHeader_bottom_labelWrapper)}>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                Tran
              </span>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                E/I
              </span>
            </div>
          </div>

          <div className={cn(styles.teethMovementHeader_bottom_cell)}>
            <div className={cn(styles.teethMovementHeader_bottom_iconWrapper)}>
              <ToothTranBLIcon />
            </div>
            <div className={cn(styles.teethMovementHeader_bottom_labelWrapper)}>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                Tran
              </span>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                B/L
              </span>
            </div>
          </div>

          <div className={cn(styles.teethMovementHeader_bottom_cell)}>
            <div className={cn(styles.teethMovementHeader_bottom_iconWrapper)}>
              <ToothTranMDIcon />
            </div>
            <div className={cn(styles.teethMovementHeader_bottom_labelWrapper)}>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                Tran
              </span>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                M/D
              </span>
            </div>
          </div>

          <div className={cn(styles.teethMovementHeader_bottom_cell)}>
            <div className={cn(styles.teethMovementHeader_bottom_iconWrapper)}>
              <ToothRotMDIcon />
            </div>
            <div className={cn(styles.teethMovementHeader_bottom_labelWrapper)}>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                Rot
              </span>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                M/D
              </span>
            </div>
          </div>

          <div className={cn(styles.teethMovementHeader_bottom_cell)}>
            <div className={cn(styles.teethMovementHeader_bottom_iconWrapper)}>
              <ToothAngMDIcon />
            </div>
            <div className={cn(styles.teethMovementHeader_bottom_labelWrapper)}>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                Ang
              </span>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                M/D
              </span>
            </div>
          </div>

          <div className={cn(styles.teethMovementHeader_bottom_cell)}>
            <div className={cn(styles.teethMovementHeader_bottom_iconWrapper)}>
              <ToothTorqBLIcon />
            </div>
            <div className={cn(styles.teethMovementHeader_bottom_labelWrapper)}>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                Torq
              </span>
              <span className={cn(styles.teethMovementHeader_bottom_label)}>
                B/L
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
